<template>
  <v-card>
    <v-card-title>
      <h2 class="modal-title">{{ 'base.edit' | translate }}</h2>
    </v-card-title>

    <v-card-content>
      <div class="mb-4">
        <v-text-field
          v-model="form.name"
          :label="'Редагувати інформацію'"
          :hint="errorMessage('name')"
          :invalid="!!errorMessage('name')"
        />
      </div>
      <div class="mb-3">
        <v-text-field
          v-model="form.calibration"
          :label="'Редагувати калібрування'"
          :hint="errorMessage('calibration')"
          :invalid="!!errorMessage('calibration')"
        />
      </div>
    </v-card-content>

    <v-card-actions>
      <v-btn :disabled="!isFormFilled" :loading="loading" @click="onUpdate">
        {{ 'base.save' | translate }}
      </v-btn>
      <delete-btn @delete="onDelete" />
    </v-card-actions>
  </v-card>
</template>

<script>
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'EditCalibrationModal',
  components: { DeleteBtn },

  props: {
    selected: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [formErrorsMixin],
  data () {
    return {
      form: {},
      errors: {
        name: null,
        calibration: null
      },
      loading: false
    }
  },

  mounted () {
    this.form = { ...this.selected }
  },

  computed: {
    isFormFilled () {
      return !!this.form.name && !!this.form.calibration
    }
  },

  methods: {
    async onUpdate () {
      this.loading = true
      this.checkValidData()

      await new Promise(resolve => setTimeout(resolve, 300))
      if (this.errors.name === null && this.errors.calibration === null) {
        const updatedData = {
          ...this.form,
          name: this.form.name.trim(),
          calibration: this.form.calibration.trim()
        }
        this.$emit('update', updatedData)
        this.$emit('close')
      }
      this.loading = false
    },
    checkValidData () {
      this.errors.name = null
      this.errors.calibration = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
      if (!this.form.calibration) {
        this.errors.calibration = ['3']
      }
    },
    onDelete () {
      this.$emit('delete', this.form.id)
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
  display: flex;
  gap: 1rem;
}

.v-card__actions button:first-child {
  flex: 1;
}
</style>
